

































import Vue from 'vue';

export default Vue.extend({
    props: ['carouselVisible', 'carouselData'],
    data() {
        return {
            swiper: null,
        };
    },
    methods: {
        closeDialog() {
            this.carouselVisible.show = false;
        },
    },
});
